export enum PraticaStats {
  CREDIT_SCORE_CRIF = 'credit-score-crif',
  ANDAMENTALE = 'analisi-andamentale',
  BILANCIO = 'analisi-bilancio',
  GARANZIE = 'analisi-garanzie',
  KYC = 'score-kyc',
  QUESTIONARIO_QUALITATIVO = 'questionario-qualitativo',
}
